import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useApp } from '../store';

export function RevealToast() {
  const { t } = useTranslation('panels');
  const { lastReveal, setLastReveal } = useApp();

  useEffect(() => {
    if (!lastReveal) return;
    const timeoutId = window.setTimeout(() => setLastReveal(null), 4500);
    return () => window.clearTimeout(timeoutId);
  }, [lastReveal, setLastReveal]);

  if (!lastReveal) return null;

  return (
    <div className="pointer-events-none absolute left-1/2 top-24 z-40 w-[min(92vw,24rem)] -translate-x-1/2 rounded-2xl border border-[var(--accent)] bg-[var(--bg-panel)] px-4 py-3 text-center shadow-xl backdrop-blur-md">
      <div className="font-[family-name:var(--font-display)] text-lg text-[var(--accent)]">{lastReveal.name}</div>
      <div className="text-sm text-[var(--ink)]">{t('revealToast.points', { count: lastReveal.points })}</div>
    </div>
  );
}
